<template>
  <span>
    <span type="primary" @click="showModal">
      <slot name="button"></slot>
    </span>
    <a-modal v-model="visible" ok-text="OK" cancel-text="Cancel" @ok="hideModal">
      <div slot="title">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        {{ title }}
      </div>
      <slot></slot>
    </a-modal>
  </span>
</template>

<script>
export default {
  name: "Information",
  data() {
    return {
      visible: false,
    };
  },
  props: {
    title: {
      type: String,
      default: 'Information',
    }
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
  },
}
</script>

<style scoped>

</style>
